export const SecretLabels: Record<
    "project" | "user" | "organization",
    {
        newSecretModalDescription: string;
        newSecretModalCreatedToast: string;
        emptyStateDescription: string;
    }
> = {
    project: {
        newSecretModalDescription:
            "Add a new secret to this project, secrets added here will override any existing organization secrets",
        newSecretModalCreatedToast: "The secret is available to all new environments created from this project.",
        emptyStateDescription: "This project has no secrets.",
    },
    user: {
        newSecretModalDescription:
            "Secrets added here will be available in all your environments and will override any existing organization or project secrets",
        newSecretModalCreatedToast: "The secret is available to all your new environments.",
        emptyStateDescription: "You don't have any secrets.",
    },
    organization: {
        newSecretModalDescription: "Secrets added here will be available in all environments in the organization",
        newSecretModalCreatedToast: "The secret is available to all new environments in the organization.",
        emptyStateDescription: "This organization has no secrets.",
    },
};
